export default __webpack_public_path__ + "static/media/takyon_logo.ff5999fe.png";